import _get from 'lodash/get';
import { toFixed } from '@/shared/utils/toFixed';
import { COIN_DISPLAY_NAMES } from '@/processes/Router/constants/common';

type useCryptoFormatterProps = {
  coin: string;
}

const COIN_DECIMALS = {
  BTC: 8,
  RVN: 2,
  KAS: 2,
  DNX: 2,
  ETC: 4,
  GRAM: 5,
  LTC: 2,
}

export const useCryptoFormatter = (props: useCryptoFormatterProps) => {
  const { coin } = props;
  const decimals = _get(COIN_DECIMALS, coin, 5);
  const displayName = _get(COIN_DISPLAY_NAMES, coin, coin);
  
  return {
    formatCrypto: (value: string | number) => {
      const amount = toFixed(value, decimals);
      return `${amount} ${displayName}`;
    },
    formatCryptoAmount: (value: string | number) => {
      return toFixed(value, decimals);
    },
    addCoinPostfix: (value: string | number) => {
      return `${value} ${displayName}`;
    }
  }
}

export default useCryptoFormatter;